module.exports = __webpack_public_path__ + "img/recharge_title_bg.6854038f.png";